import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

import debounce from 'lodash-es/debounce';
import each from 'lodash-es/each';
import SmoothScroll from 'smooth-scroll';
import objectFitImages from 'object-fit-images';
import cookiesEnabled from '../utils/cookiesEnabled.js';
import { wrapTable, wrapIframe } from '../utils/theme-rte.js';
import '../utils/klarnaConfig.js'; // Initialize Klarna configuration
import { initVideoCoordinator } from '../utils/videoCoordinator.js';
import { initScrollPauseVideos } from '../utils/scrollPauseVideos.js';
import { applyVideoFetchPrefix } from '../utils/videoUrlPrefix.js';

// Expose to Constructor's inline JS (Liquid-rendered, not part of the bundle)
// so it can share the same per-placement + DPR-aware Cloudinary URL builder.
if (typeof window !== 'undefined') {
  window.applyVideoFetchPrefix = applyVideoFetchPrefix;
}

import sections from '../utils/theme-sections';
import '../sections/product';

import * as Infinite from '../infinite-loader';

import 'simplebar';

import RteVideo from '../components/rte-video';

import subNav from '../components/subnav';
import HeaderNav from '../components/HeaderNav';
import mobileNav from '../components/mobileNav';
//import ProductStickyBuy from '../components/ProductStickyBuy';
import ProductImages from '../components/ProductImages';
import Accordion from '../components/Accordion';
import ProductOptions from '../components/ProductOptions';
import ShoppableImage from '../components/ShoppableImage';
// import ChatButtonPosition from '../components/ChatButtonPosition';
// import BackToTopButton from '../components/BackToTopButton';
// import scrollToElement from '../components/scrollToElement';
import ProductOverview from '../sections/ProductOverview';
import StoreDetailArticleContent from '../components/StoreDetailArticleContent';
import Form from '../components/Form';
// import AmbassadorForm from '../components/AmbassadorForm';
// import PressContactForm from '../components/PressContactForm';
// import RecentArticlesCarousel from '../components/RecentArticlesCarousel';
import RevealThumbs from '../components/RevealThumbs';
import RegisterForm from '../components/RegisterForm';
import PreheaderDropdown from '../components/PreheaderDropdown';
// import ArticleTileCustom from '../components/ArticleTileCustom';
import QuickView from '../components/QuickView';
// import AuthorBlock from '../components/AuthorBlock';
import AdMindPageLoad from '../components/AdMind/pageLoad';
import '../components/AdMind/impressionsCertona';
import '../components/AdMind/cart';
import LinkStoreScrollPosition from '../core/linkStoreScrollPosition';
import navMenu from '../components/navMenu';
import HomepagePromoTracking from '../core/HomepagePromoTracking';
//import AdmindRecommendedSlider from '../core/AdmindRecommendedSlider';
import ShippingStatus from '../components/ShippingStatus';
import PDPVideo from '../components/PDPVideo';
import GiftCardProduct from '../components/GiftCardProduct';
import Tooltip from '../components/Tooltip/index.js';
import QuickSearchAutocomplete from '../components/QuickSearch';

// Footer components
import CountrySelector from '../components/CountrySelector';
import NewsletterSignUp from '../components/NewsletterSignUp';

// Wordpress Modules
// import CMS_2UpImages from '../CMS/CMS-2UpImages';
// import CMS_Blockquote from '../CMS/CMS-Blockquote';
// import CMS_CollectionSlider from '../CMS/CMS-CollectionSlider';
// import CMS_FeaturedProductReview from '../CMS/CMS-FeaturedProductReview';
// import CMS_FlexibleColumns from '../CMS/CMS-FlexibleColumns';
// import CMS_FullWidthImage from '../CMS/CMS-FullWidthImage';
// import CMS_HeroBanner from '../CMS/CMS-HeroBanner';
// import CMS_ImageSlider from '../CMS/CMS-ImageSlider';
// import CMS_ProductSlider from '../CMS/CMS-ProductSlider';
// import CMS_RelatedContent from '../CMS/CMS-RelatedContent';
// import CMS_ShoppableImage from '../CMS/CMS-ShoppableImage';
// import CMS_SplitContent from '../CMS/CMS-SplitContent';
// import CMS_TextHeading from '../CMS/CMS-TextHeading';
// import CMS_Video from '../CMS/CMS-Video';
// import CMS_WysiwygContent from '../CMS/CMS-WysiwygContent';

// *** Auto-generated imports will be placed below. DO NOT EDIT THIS LINE! ***
import PDP from '../sections/PDP';
import Cart from '../sections/Cart';
// import GiftCardHero from '../sections/GiftCardHero';
// import GiftCardPage from '../sections/GiftCardPage';
// import HalloweenBanner from '../sections/HalloweenBanner';
// import HalloweenQuadPods from '../sections/HalloweenQuadPods';
// import HalloweenDualPods from '../sections/HalloweenDualPods';
// import OccassionPage from '../sections/OccassionPage';
// import OccassionDualPods from '../sections/OccassionDualPods';
import SupportContent from '../sections/SupportContent/index';
import SupportHeader from '../sections/SupportHeader/index';
import ArticleThumbCarousel from '../sections/ArticleThumbCarousel/index';
import ArticleCarousel from '../sections/ArticleCarousel/index';
import PressHeading from '../sections/PressHeading/index';
import PressContact from '../sections/PressContact/index';
import PressTagCarousel from '../sections/PressTagCarousel/index';
// import BlogArticleThumbCarousel from '../sections/BlogArticleThumbCarousel/index';
// import BlogLatestGrid from '../sections/BlogLatestGrid/index';
// import UpcomingEvents from '../sections/UpcomingEvents/index';
// import BlogCarousel from '../sections/BlogCarousel/index';
// import BlogLatestPosts from '../sections/BlogLatestPosts/index';
// import BlogFeaturedCarousel from '../sections/BlogFeaturedCarousel/index';
// import BlogLatestPods from '../sections/BlogLatestPods/index';
// import BlogTagsCarousel from '../sections/BlogTagsCarousel/index';
// import BlogMainInterrupterCarousel from '../sections/BlogMainInterrupterCarousel/index';
// import CarouselTimeLine from '../sections/CarouselTimeLine/index';
import VIPSignup from '../sections/VIPSignup/index';
import CarouselLookBook from '../sections/CarouselLookBook/index';
// import CollectionCarouselSubheading from '../sections/CollectionCarouselSubheading/index';
import PodsAboveBelow from '../sections/PodsAboveBelow/index';
// import ImageTextContent from '../sections/ImageTextContent/index';
import HeroDualImage from '../sections/HeroDualImage/index';
import StoreInventorySearch from '../components/StoreInventory/StoreInventorySearch.js';
import VideoPlayerV2 from '../sections/VideoPlayerV2';
// GTM Events
import GTMGlobal from '../components/GTMEvents/index';

// Frame Blocks
import ProductTiles from '../blocks/ProductTiles/index.js';
import Carousel from '../blocks/Carousel/index.js';
import blockVideo from '../blocks/video';

// CORE
import iosDisableTabArrows from '../core/iosDisableTabArrows';
import locales_by_country from '../utils/locales_by_country';
import formatFreeShippingThresholds from '../utils/formatFreeShippingThreshold';
import '../sections/Recommendations';
import RecentlyViewed from '../sections/RecentlyViewed';
import PLP from '../sections/PLP';
import { cnstrcSdk } from '../core/ConstructorSdk';

/* Start constructor sdk */
window.cnstrcSdk = cnstrcSdk;
/* End constructor sdk */

window.formatter = new window.Intl.NumberFormat(`${locales_by_country(window.theme.country_iso)}`, {
  style: 'currency',
  currency: window.theme.currency_iso,
  numberingSystem: 'latn',
});

// Exposed so the inline announcement-bar reveal handler in layout/theme.liquid can
// format the free-shipping threshold before the bar becomes visible (no empty flash).
window.formatFreeShippingThresholds = formatFreeShippingThresholds;
new PLP().init();

/* ********* IOS 13 FIX - START ********** */

// import flickityiOS13Fix from '../utils/flickityiOS13Fix';

/* Uncomment to test optimizely experiments */

// window.optimizely_mobile_atb = true;
// window.optimizely_certona = {
//   product1: "product1_test_rr",
//   product2: "product2_test_rr",
//   cart: "cart1_test_rr"
// };

// window.optimizely_recommendations = {
//   pageType: 'collection,product',
// };

let startX = 0;

const handleTouchStart = (e) => {
  startX = e.touches[0].clientX;
};

const handleTouchMove = (e) => {
  if (e.touches.length > 1) {
    return;
  }

  if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable) {
    e.preventDefault();
  }
};

const initEventListeners = debounce(() => {
  document.querySelectorAll('.flickity-enabled').forEach((item) => {
    item.removeEventListener('touchstart', handleTouchStart);
    item.removeEventListener('touchmove', handleTouchMove);

    item.addEventListener('touchstart', handleTouchStart);
    item.addEventListener('touchmove', handleTouchMove);
  });
}, 500);

/* ********* IOS 13 FIX - END ********** */

window.clearAllBodyScrollLocks = clearAllBodyScrollLocks;

window.slate = window.slate || {};
window.theme = window.theme || {};

window.addEventListener('DOMContentLoaded', () => {
  /* ********* IOS 13 FIX - START ********** */

  let urlWithParams = new URL(window.location.href);

  if (urlWithParams) {
    let turboLinkParam = urlWithParams.searchParams.get('tl');
    if (turboLinkParam) {
      urlWithParams.searchParams.delete('tl');
      history.replaceState({}, '', urlWithParams.href);
    }
  }

  ProductOverview();

  // Pause other managed autoplay videos whenever one starts playing.
  initVideoCoordinator();

  // Pause any video that scrolls out of the viewport (all scenarios).
  initScrollPauseVideos();

  initEventListeners();
  document.addEventListener('carouselDidInit', initEventListeners);

  /* ********* IOS 13 FIX - END ********** */

  // Debounce function in vanilla JavaScript
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }

  // Event listener for 'productOverviewCarouselsDidInit'
  document.addEventListener(
    'productOverviewCarouselsDidInit',
    debounce((e) => {
      const params = e.detail;
      const event = new CustomEvent('debouncedProductOverviewCarouselsDidInit', { detail: params });
      document.dispatchEvent(event);
    }, 500),
  );

  /* Global Smooth Scroll method */
  window.smoothScroll = new SmoothScroll('[data-scroll-animation]', {
    speed: 500,
    speedAsDuration: true,
  });

  sections.load('product');

  sections.load('product');

  /* Frame Blocks */
  ProductTiles();
  Carousel();
  blockVideo();

  // CMS Modules
  // CMS_2UpImages();
  // CMS_Blockquote();
  // CMS_CollectionSlider();
  // CMS_FeaturedProductReview();
  // CMS_FlexibleColumns();
  // CMS_FullWidthImage();
  // CMS_HeroBanner();
  // CMS_ImageSlider();
  // CMS_ProductSlider();
  // CMS_RelatedContent();
  // CMS_ShoppableImage();
  // CMS_SplitContent();
  // CMS_TextHeading();
  // CMS_Video();
  // CMS_WysiwygContent();

  // AdMindPageLoad();

  each(Infinite, (component) => {
    component();
  });

  RteVideo();

  subNav();
  HeaderNav();
  mobileNav();
  navMenu();
  //ProductStickyBuy();
  ProductImages();
  Accordion();
  // FindStore();
  ProductOptions();
  ShoppableImage();
  // ChatButtonPosition();
  // BackToTopButton();

  StoreDetailArticleContent();
  // RecentArticlesCarousel();
  LinkStoreScrollPosition();
  HomepagePromoTracking();
  //AdmindRecommendedSlider();
  ShippingStatus();
  StoreInventorySearch();

  // *** Auto-generated imports will be executed below. DO NOT EDIT THIS LINE! ***
  Tooltip();
  CountrySelector();
  NewsletterSignUp();
  PDP();
  Cart();
  window.recommendations.init();
  RecentlyViewed();
  // Initialize QuickSearch autocomplete (Constructor API)
  window.quickSearchAutocomplete = new QuickSearchAutocomplete();
  window.quickSearchAutocomplete.init();
  // GiftCardHero();
  // GiftCardPage();
  // HalloweenBanner();
  // HalloweenQuadPods();
  // HalloweenDualPods();
  // OccassionPage();
  // OccassionDualPods();
  // SupportArticleAccordions();
  // SupportArticleThumbs();
  SupportContent();
  SupportHeader();
  ArticleThumbCarousel();
  ArticleCarousel();
  PressHeading();
  PressContact();
  PressTagCarousel();
  // BlogArticleThumbCarousel();
  // BlogLatestGrid();
  // UpcomingEvents();
  // BlogCarousel();
  // BlogLatestPosts();
  // BlogFeaturedCarousel();
  // BlogLatestPods();
  // BlogTagsCarousel();
  // BlogMainInterrupterCarousel();
  // CarouselTimeLine();
  RevealThumbs();

  // *** Auto-generated imports will be executed below. DO NOT EDIT THIS LINE! ***
  VIPSignup();
  CarouselLookBook();
  // CollectionCarouselSubheading();
  // ImageTextContent();
  VideoPlayerV2();
  HeroDualImage();
  // scrollToElement();
  Form();
  GTMGlobal();
  // AmbassadorForm();
  // PressContactForm();
  RegisterForm();
  PreheaderDropdown();
  //Wishlist();
  // ArticleTileCustom();
  QuickView();
  // AuthorBlock();
  PodsAboveBelow();

  iosDisableTabArrows();

  GiftCardProduct();
  // Fire resize and scroll on page load and section load
  window.dispatchEvent(new Event('resize'));
  window.dispatchEvent(new Event('scroll'));

  document.addEventListener('shopify:section:load', () => {
    window.dispatchEvent(new Event('scroll'));
    window.dispatchEvent(new Event('resize'));
  });

  // Target tables to make them scrollable
  const tableSelectors = '.rte table';

  wrapTable({
    $tables: document.querySelectorAll(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  const iframeSelectors = '.rte iframe[src*="youtube.com/embed"],' + '.rte iframe[src*="player.vimeo"]';

  wrapIframe({
    $iframes: document.querySelectorAll(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper',
  });

  document.addEventListener('shopify:section:load', (e) => {
    if (e.detail.sectionId === 'INF-ArticleContent' || e.detail.sectionId === 'INF-PageContent') {
      wrapIframe({
        $iframes: document.querySelectorAll(iframeSelectors),
        iframeWrapperClass: 'rte__video-wrapper',
      });
    }
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (cookiesEnabled()) {
    document.documentElement.classList.replace('supports-no-cookies', 'supports-cookies');
  }

  document.addEventListener('cartDidOpen', () => {
    setTimeout(() => {
      clearAllBodyScrollLocks();

      document.querySelectorAll('[data-slider-cart-scroll]').forEach((el) => {
        disableBodyScroll(el);
      });
    }, 1);
  });

  objectFitImages();

  /* Initialize PDPVideo component */
  if (document.querySelector('#ProductCarousel')) {
    const pdpVideo = new PDPVideo(document);
    pdpVideo.init(document);
  }

  /* AdMind pageload */
  AdMindPageLoad();
});

['shopify:section:load', 'shopify:section:select', 'shopify:section:reorder', 'shopify:block:select'].forEach(
  (event) => {
    document.addEventListener(event, () => {
      ProductTiles();
      Carousel();
      blockVideo();
    });
  },
);
